<template>
    <div class="row shadow rounded my-2 p-2 bg-body ">
        <div v-if="marquage" class="border border-3 border-success rounded mb-2"></div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name:"SectionContainer",
    props:{
        marquage:{
            type:Boolean,
            default:false
        },

    }
}
</script>